import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuItem } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownItem, dropdownItemClickable, dropdownItemContent } from '../../shared/styles/item.vanilla.mjs';
import { DropdownSlot } from '../slot/Slot.mjs';
import { dropdownItemDangerousVariants } from './item.vanilla.mjs';

const DropdownItem = forwardRef(
  ({
    children,
    className: classNameFromProps,
    danger,
    leftSlot,
    onPointerUp,
    ...props
  }, forwardedRef) => {
    const canAsChild = props.asChild === true && isNil(leftSlot);
    const className = classNames(
      dropdownItem,
      !props.disabled && dropdownItemClickable,
      dropdownItemDangerousVariants({ danger }),
      classNameFromProps
    );
    const handlePointerUp = composeEventHandlers(onPointerUp, (event) => {
      if (!event.isDefaultPrevented()) {
        event.preventDefault();
      }
    });
    return /* @__PURE__ */ jsx(
      DropdownMenuItem,
      {
        "data-scope": "dropdown",
        "data-part": "item",
        className,
        onPointerUp: handlePointerUp,
        ref: forwardedRef,
        ...props,
        children: canAsChild ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(DropdownSlot, { "data-scope": "dropdown", "data-part": "item-left-slot", children: leftSlot }),
          /* @__PURE__ */ jsx(
            "div",
            {
              "data-scope": "dropdown",
              "data-part": "item-content",
              className: dropdownItemContent,
              children
            }
          )
        ] })
      }
    );
  }
);

export { DropdownItem };
//# sourceMappingURL=Item.mjs.map
